import { formatarDataChip } from "../painel-analise-fiscal";
import {
  Autocomplete,
  DatePickerMui,
  FiltrosChips,
  FiltrosDrawer,
  FiltrosSecao,
  TextField,
} from "../../../components";

const POPPER_SX = { sx: { zIndex: 9000 } };

function chipsAtivos(filtros, acessosEmpresas, aplicar) {
  const remover = (patch) => aplicar({ ...filtros, ...patch });
  const chips = [
    {
      key: "periodo",
      icon: "ph-calendar-blank",
      label: filtros.ate
        ? new Date(filtros.ate).toLocaleDateString("pt-BR", {
            month: "long",
            year: "numeric",
          })
        : `${formatarDataChip(filtros.de)} – ${formatarDataChip(filtros.ate)}`,
    },
  ];
  if (acessosEmpresas.length > 0) {
    filtros.empresas.forEach((e) =>
      chips.push({
        key: `emp-${e.id}`,
        icon: "ph-buildings",
        label: e.razaoSocial,
        onDelete: () =>
          remover({ empresas: filtros.empresas.filter((x) => x.id !== e.id) }),
      }),
    );
  }
  return chips;
}

function PainelAnaliseFiscalFiltros({
  open,
  setOpen,
  filtros,
  filtrosPadrao,
  acessosEmpresas,
  onAplicar,
  draft,
  setDraft,
}) {
  const setCampo = (campo, valor) =>
    setDraft((prev) => ({ ...prev, [campo]: valor }));

  const aplicar = () => {
    onAplicar(draft);
    setOpen(false);
  };

  return (
    <>
      <FiltrosChips chips={chipsAtivos(filtros, acessosEmpresas, onAplicar)} />
      <FiltrosDrawer
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onLimpar={() => setDraft(filtrosPadrao)}
        onAplicar={aplicar}
      >
        <FiltrosSecao titulo="Período">
          <DatePickerMui
            label="Mês / Ano"
            format="MM/yyyy"
            views={["month", "year"]}
            slotProps={{ popper: POPPER_SX }}
            value={draft.ate ? new Date(draft.ate) : null}
            onChange={(date) => {
              if (!date || isNaN(date)) return setCampo("ate", null);
              const de = new Date(
                date.getFullYear(),
                date.getMonth(),
                1,
              ).toISOString();
              const ate = new Date(
                date.getFullYear(),
                date.getMonth() + 1,
                0,
              ).toISOString();
              setDraft((prev) => ({ ...prev, de, ate }));
            }}
          />
        </FiltrosSecao>
        {acessosEmpresas.length > 0 && (
          <FiltrosSecao titulo="Unidades">
            <Autocomplete
              multiple
              filterSelectedOptions
              options={acessosEmpresas}
              disableCloseOnSelect
              getOptionLabel={(opt) => opt?.razaoSocial ?? ""}
              isOptionEqualToValue={(opt, val) =>
                String(opt?.id) === String(val?.id)
              }
              value={draft.empresas}
              onChange={(_, val) => setCampo("empresas", val)}
              slotProps={{ popper: POPPER_SX }}
              renderInput={(params) => (
                <TextField {...params} label="Unidade(s)" />
              )}
            />
          </FiltrosSecao>
        )}
      </FiltrosDrawer>
    </>
  );
}

export default PainelAnaliseFiscalFiltros;
